import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import CountCard from '../components/CountCard'
import PageHeading from '../components/PageHeading'

interface InventoryActionsData {
  name: string
  icon: string
  heading: string
  to: string
}

interface InventoryActionsProps extends RouteComponentProps {}

class InventoryActions extends Component<InventoryActionsProps> {
  actions: InventoryActionsData[] = [
    {
      name: 'inventoryCreate',
      icon: 'archive',
      heading: `${i18n("Create Inventory")}`,
      to: routes.inventoryCreate
    },
    {
      name: 'transfer',
      icon: 'direction',
      heading: `${i18n("Transfer Inventory")}`,
      to: routes.transfer
    },
    {
      name: 'ship',
      icon: 'truck',
      heading: `${i18n("Ship Inventory")}`,
      to: routes.ship
    }
  ]

  constructor (props: InventoryActionsProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (to: string) {
    this.props.history.push(to)
  }

  inventoryAction (action: InventoryActionsData) {
    return (
      <div
        className="cursor-pointer"
        onClick={() => this.handleClick(action.to)}
        key={action.name}>
        <CountCard
          type="primary"
          icon={action.icon}
          heading={action.heading} />
      </div>
    )
  }

  get inventoryActions () {
    return this.actions.map(action => this.inventoryAction(action))
  }

  render () {
    return (
      <div className="mb-8">
        <PageHeading text={i18n("Inventory Actions")} />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {this.inventoryActions}
        </div>
      </div>
    )
  }
}

export default withRouter(InventoryActions)
